import { PhoneIcon, MessageSquareIcon, UserIcon, CircleDashedIcon, ShuffleIcon, MailIcon } from 'lucide-react';
import { format, intervalToDuration } from 'date-fns';
import { clsx } from 'clsx';
import { SearchContactsItem } from '../../../api/api-client';

export const ContactRow = (props: {
  contact: SearchContactsItem;
  onSelect: (contact: SearchContactsItem) => void;
  isSelected: boolean;
}) => {
  const formatTimestamp = (timestamp: string) => {
    const date = new Date(timestamp);

    return format(date, 'h:mm a');
  };

  const getChannelIcon = (channel: SearchContactsItem['channel']) => {
    switch (channel) {
      case 'VOICE':
        return <PhoneIcon className='size-3' />;
      case 'CHAT':
        return <MessageSquareIcon className='size-3' />;
      case 'TASK':
        return <ShuffleIcon className='size-3' />;
      case 'EMAIL':
        return <MailIcon className='size-3' />;
      default:
        return <CircleDashedIcon className='size-3' />;
    }
  };

  const getInitiationMethodLabel = (method: SearchContactsItem['initiationMethod']) => {
    switch (method) {
      case 'INBOUND':
        return 'Inbound';
      case 'OUTBOUND':
        return 'Outbound';
      case 'TRANSFER':
        return 'Transfer';
      case 'CALLBACK':
        return 'Callback';
      case 'WEBRTC_API':
        return 'WebRTC';
      case 'AGENT_REPLY':
        return 'Agent Reply';
      case 'API':
        return 'API';
      case 'DISCONNECT':
        return 'Disconnect';
      case 'EXTERNAL_OUTBOUND':
        return 'External';
      case 'FLOW':
        return 'Flow';
      case 'MONITOR':
        return 'Monitor';
      case 'QUEUE_TRANSFER':
        return 'Queue Transfer';
      default:
        return method;
    }
  };

  const duration = !props.contact.disconnectTimestamp
    ? intervalToDuration({
        start: new Date(props.contact.initiationTimestamp),
        end: new Date()
      })
    : intervalToDuration({
        start: new Date(props.contact.initiationTimestamp),
        end: new Date(props.contact.disconnectTimestamp)
      });

  const durationString = `${duration.hours ? String(duration.hours).padStart(2, '0') : '00'}:${duration.minutes ? String(duration.minutes).padStart(2, '0') : '00'}:${duration.seconds ? String(duration.seconds).padStart(2, '0') : '00'}`;

  return (
    <div
      className={clsx(
        'py-2 px-4 cursor-pointer',
        'border-b border-neutral-200 transition-shadow',
        'last:border-b-0',
        // props.contact.isPending && 'bg-green-50!',
        // !props.contact.isPending && 'hover:bg-sidebar-primary-foreground',
        props.isSelected && 'shadow-[inset_4px_0_0_var(--color-blue)]',
        // props.isSelected ? (props.contact.isPending ? 'bg-green-50' : 'bg-neutral-100') : 'bg-white'
        props.isSelected ? 'bg-muted' : 'bg-white hover:bg-accent'
      )}
      onClick={() => props.onSelect(props.contact)}
    >
      <div className='flex items-start justify-between w-full'>
        <div className='flex flex-col gap-1 w-full'>
          <div className='flex items-center gap-2 text-xs text-sidebar-foreground'>
            <div className='flex items-center'>
              <p className='font-medium truncate tabular-nums'>{props.contact.id}</p>
            </div>
          </div>

          <div className='flex justify-between gap-2'>
            <div className='flex items-center gap-2 text-muted-foreground'>
              <span className='text-xs font-medium'>{getChannelIcon(props.contact.channel)}</span>
              {props.contact.initiationMethod && (
                <span className='text-xs font-medium'>{getInitiationMethodLabel(props.contact.initiationMethod)}</span>
              )}
              <span className='text-xs font-medium font-mono tabular-nums'>{durationString}</span>
              {props.contact.agent && <UserIcon className='size-3 stroke-[2.5]' />}
            </div>

            <div className='flex items-center gap-2'>
              {/* <span>{getChannelIcon(props.contact.channel)}</span> */}
              {/* <span className='text-xs font-medium lowercase'>{props.contact.channel}</span> */}
              <span className='text-xs font-medium text-muted-foreground tabular-nums'>
                {formatTimestamp(props.contact.initiationTimestamp)}
              </span>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
